import React, { useReducer } from 'react'
import UserProfileModel from '../models/user-models/UserProfileModel'

const defaultState = {
  user: new UserProfileModel(),
}

const reducer = (state, action) => {
  console.log('ProposalContext state', state, action)
  let newState = state
  switch (action.type) {
    case 'USER_INFORMATION':
      newState = { ...state, user: action.data }
      break
    default:
      newState = state
      break
  }

  return newState
}

export const ProposalSessionContextStore = React.createContext(defaultState)

const ProposalSessionContext = (props) => {
  const [state, dispatch] = useReducer(reducer, defaultState)
  // const location = useLocation()
  // const history = useHistory()

  // React.useEffect(() => {
  //     var params = new URLSearchParams(location.search)

  //     if(params.has('token')) {
  //         let token = params.get('token')
  //         StorageService.setItem(StorageKey.TOKEN, token);
  //     }

  // }, [])

  return (
    <ProposalSessionContextStore.Provider value={{ ...state, dispatch }}>
      {props.children}
    </ProposalSessionContextStore.Provider>
  )
}

export default ProposalSessionContext
